import { render, staticRenderFns } from "./SearchSchool.vue?vue&type=template&id=7841bc3c"
import script from "./SearchSchool.vue?vue&type=script&lang=js"
export * from "./SearchSchool.vue?vue&type=script&lang=js"
import style0 from "./SearchSchool.vue?vue&type=style&index=0&id=7841bc3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Card: require('/app/nuxt/components/Card.vue').default,Col: require('/app/nuxt/components/Col.vue').default,Row: require('/app/nuxt/components/Row.vue').default})
